"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.ThirdTitle = exports.SecondTitle = exports.Col = exports.Row = exports.TopRow = exports.MenuItems = exports.MegaMenu = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const Container_1 = __importDefault(require("../../../../Components/UI/Container"));
const Typography_1 = __importDefault(require("../../../UI/Typography"));
exports.MegaMenu = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding-top: ${props => props.theme.spacing.m3}px;
  position: absolute;
  left: 0;
  background-color: white;
  width: 100%;
  transform: ${props => (props.isMegaMenuOpen ? 'scaleY(0)' : 'scaleY(1)')};
  transform-origin: 0% 0%;
  animation: ${props => props.theme.animations.easeInOut}
    ${props => (props.isMegaMenuOpen ? props.theme.themeKeyframes.scaleYIn : props.theme.themeKeyframes.scaleYOut)}
    forwards;
`;
exports.MenuItems = (0, styled_components_1.default)(Container_1.default) `
  padding-bottom: ${props => props.theme.spacing.xl1}px;
  opacity: 0;
  animation: ${props => props.theme.animations.easeInOut} ${props => props.isMegaMenuOpen && '0.2s'}
    ${props => (props.isMegaMenuOpen ? props.theme.themeKeyframes.fadeIn : props.theme.themeKeyframes.fadeOut)} forwards;
`;
exports.TopRow = (0, styled_components_1.default)(styled_bootstrap_grid_1.Row) `
  margin: 0 0 ${props => props.theme.spacing.m3}px 0;
  align-items: center;
  justify-content: space-between;
`;
exports.Row = (0, styled_components_1.default)(styled_bootstrap_grid_1.Row) `
  margin: 0;
`;
exports.Col = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  display: flex;
  flex-direction: column;
  padding: 0 0 ${props => props.theme.spacing.m3}px ${props => props.theme.spacing.s5}px;
  border-right: 1px solid ${props => props.theme.palette.DARK_GRAY_20};

  &:only-child {
    border: none;
  }

  ${props => props.columns === 4
    ? `
    :nth-of-type(3n) {
      border: none;
    }

    :nth-of-type(1),
    :nth-of-type(3n + 1) {
      padding-left: 0;
    }

    :nth-last-of-type(-n + 3) {
      padding-bottom: 0;
    }
  `
    : `
    :nth-of-type(4n) {
      border: none;
    }

    :nth-of-type(1),
    :nth-of-type(4n + 1) {
      padding-left: 0;
    }

    :nth-last-of-type(-n + 4) {
      padding-bottom: 0;
    }
  `}
`;
exports.SecondTitle = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.BLUE_100};
  ${props => !props.hasChildren && `margin-bottom: ${props.theme.spacing.m3}px;`}
`;
exports.ThirdTitle = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.LIGHT_BLACK};
  margin-top: ${props => props.theme.spacing.s3}px;
`;
exports.Link = styled_components_1.default.a `
  color: inherit;
  text-decoration: none;
  transition: ${props => props.theme.attributes.transition.fast};

  &:hover {
    color: ${props => props.theme.palette.LIGHT_BLACK};
    text-decoration: underline;
    text-decoration-color: ${props => props.theme.palette.LIGHT_BLACK};
  }
`;
exports.default = {
    MegaMenu: exports.MegaMenu,
    MenuItems: exports.MenuItems,
    TopRow: exports.TopRow,
    Row: exports.Row,
    Col: exports.Col,
    SecondTitle: exports.SecondTitle,
    ThirdTitle: exports.ThirdTitle,
    Link: exports.Link
};
